:host {
  display: none;
  width: 100%;
  height: 100%;
  background-color: var(--white-layout-300-primary);
}

:host([data-is-visible]) {
  display: block;
}

.wrapper {
  flex-direction: column;

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .form-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  &.is-error {
    .form-wrapper {
      display: none;
    }
    .loading-error {
      display: block;
    }
  }

  .form-wrapper {
    min-width: 500px;
    width: 100%;
    height: auto;
    overflow-y: scroll;
    padding: 0 calc(4 * var(--spacer));
  }
}

.loading-error {
  display: none;
  height: auto;
  width: 500px;
  margin: auto;

  &--message {
    max-width: 310px;
    line-height: 1.25;
  }
}

.form-section {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  align-items: flex-start;
  flex-direction: column;
  #window-name-form-field {
    gz-input {
      margin-left: calc(var(--spacer) * 2);
      width: 400px;
    }
    gz-input-error {
      margin-left: calc(var(--spacer) * 1.2);
    }
  }
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.form-subtitle + .form-section {
  margin-top: calc(var(--spacer) * 2.5);
}

.form-section + .form-subtitle {
  margin-top: calc(var(--spacer) * 3.5);
}

.bottom-buttons {
  width: 100%;
  flex-basis: 65px;
  min-height: 65px;
  margin-top: auto;
  display: flex;
  align-items: center;

  border-top: 1px solid var(--chart-101-pressed-dividers);
  padding: calc(1.75 * var(--spacer)) calc(5 * var(--spacer));

  gz-button {
    margin-right: calc(var(--spacer) * 2);

    &#btnCancel {
      margin-left: auto;
      margin-right: 0;
    }
  }
}

#others-can-make-changes-form-field {
  margin-bottom: calc(2 * var(--spacer));
}

#maintenance-type-title {
  text-transform: uppercase;
}
